<template>
  <div>
    <wd-navbar>
      <div slot="left" class="middle" @click="$goBack">
        <wd-icon name="arrow-left" />
      </div>
      <div>
        <span>我的设置</span>
      </div>
    </wd-navbar>

    <div style="background-color: #f6f6f6">
      <wd-cell class="cellList" style="font-size: 14px" :is-link="false">
        <div slot="title" style="white-space: nowrap">
          账号：{{ userInfo.userid || "--" }}
        </div>
        <div slot="label" style="font-size: 14px; white-space: nowrap">
          手机：{{ userInfo.phoneNum || "--" }}
        </div>
        <div
          slot="icon"
          style="display: flex; align-items: center; margin-right: 20px"
        >
          <img src="~@/assets/img/icon-avatar.png" style="width: 40px" />
        </div>
      </wd-cell>
      <div class="list-group" style="border-top: 10px solid #edf3ff">
        <!-- #dfe9ff -->
        <wd-cell
          class="cellList group-list-cell-icon"
          style="font-size: 14px"
          :is-link="true"
          to="/bind"
        >
          <div slot="title">切换项目</div>
          <div slot="icon">
            <img
              src="~@/assets/img/icon-toggle.png"
              style="width: 20px; margin-right: 10px"
              alt=""
            />
          </div>
        </wd-cell>
        <wd-cell
          class="cellList group-list-cell-icon"
          style="font-size: 14px"
          :is-link="true"
          @click="logout"
        >
          <div slot="title">退出登录</div>
          <div slot="icon">
            <img
              src="~@/assets/img/icon-exit.png"
              style="width: 20px; margin-right: 10px"
              alt=""
            />
          </div>
        </wd-cell>
      </div>
    </div>

    <wd-tabbar v-model="tabbar" fixed border>
      <!-- <wd-tabbar-item icon="wd-icon-bags" class="tabbarClass">
        <template #icon>
          <img class="img-icon" />
        </template>
        首页
      </wd-tabbar-item> -->
      <wd-tabbar-item icon="wd-icon-bags" class="tabbarClass" to="/home">
        <template #icon>
          <img class="img-icon" src="~@/assets/img/icon-homeDefult.png" />
        </template>
        首页
      </wd-tabbar-item>
      <wd-tabbar-item icon="wd-icon-setting" class="tabbarClass">
        <template #icon>
          <img class="img-icon" src="~@/assets/img/icon-configActive.png" />
        </template>
        设置
      </wd-tabbar-item>
    </wd-tabbar>
  </div>
</template>

<script>
export default {
  // name: "configure",
  data() {
    return {
      userInfo: {
        userid: "",
        phoneNum: "",
        roleKey: "",
      },
      tabbar: 1,
    };
  },
  created() {
    this.userInfo.phoneNum = localStorage.getItem("phoneNum");
    this.userInfo.userid = localStorage.getItem("appUserId");
    this.userInfo.roleKey = localStorage.getItem("roleId");
  },
  methods: {
    goto(url) {
      this.$router.push(url);
      console.log(url, "啥");
    },
    logout() {
      this.$messageBox
        .confirm("确认退出登录？", "提示")
        .then(() => {
          localStorage.removeItem("appUserId");
          localStorage.removeItem("phoneNum");
          localStorage.removeItem("roleKey");
          this.$toast.success("退出成功！");
          setTimeout(() => {
            this.$router.push("/login");
          }, 500);
        })
        .catch((err) => {});
    },
  },
};
</script>

<style lang="less" scoped>
.cellList {
  /deep/ .wd-cell__wrapper {
    align-items: center;
    .wd-cell__title {
      flex: 2;
    }
  }
}
.list-group {
  .cellList {
    border-top-width: 0px;
  }
}
.wd-tabbar {
  border-radius: 10px 10px 0 0;
  box-shadow: 0 0 5px 0px rgba(173, 181, 189, 0.5);
  &::after {
    height: 0;
  }
}
.tabbarClass {
  ::v-deep .wd-tabbar-item__label {
    font-size: 14px;
    font-family: 微软雅黑;
    margin-top: -3px;
    font-weight: bold;
    color: #ced4da;
  }
}
.tabbarClass.is-active {
  ::v-deep .wd-tabbar-item__label {
    font-weight: bold;
    color: #4d80f0;
  }
}
</style>
